// @flow
export const required = (value: any) => (value ? undefined : 'Required')

export const validateDobDay = (value: any) =>
  value > 0 && value <= 31 ? undefined : "Oh, you've entered an invalid date of birth here"

export const validateDobMonth = (value: any) =>
  value > 0 && value <= 12 ? undefined : "Oh, you've entered an invalid date of birth here"

export const validateDobYear = (value: any) => {
  if (value < 1819) {
    return "Oh, you've entered an invalid date of birth here"
  }
  if (value > 2004) {
    return "It seems that you're a bit young to book a room with us"
  }
  return undefined
}

export const validateFloor = (otherField: string) => (value: Object, allValues: Object) => {
  if (allValues.hasOwnProperty('roomType')) {
    if (allValues.roomType.hasOwnProperty('value')) {
      if (allValues.roomType.value === 'one_bed_flat') {
        return value.value === 'lower'
          ? 'One Bedroom Flats are only available on higher floors'
          : undefined
      }
    }
  }
}

export const validateAdmin = (values: Object) => {
  const errors = {}
  if (!values.roomType || (values.roomType && values.roomType.value === '')) {
    errors.roomType = 'Oh, you need to select a room type'
  }
  if (!values.yourName || (values.yourName && values.yourName.value === '')) {
    errors.yourName = 'Oh, you need to select your name'
  }
  if (!values.preferredFloor || (values.preferredFloor && values.preferredFloor.value === '')) {
    errors.preferredFloor = 'Oh, you need to select a floor preference'
  }
  if (!values.bookingType) {
    errors.bookingType = 'Oh, you need to select a reservation type'
  }

  if (!values.digitalVerification) {
    errors.digitalVerification = 'Oh, you need to select an option here'
  }

  if (
    !values.corporate_contact ||
    (values.corporate_contact && values.corporate_contact.value === '')
  ) {
    errors.corporate_contact = 'Oh, you need to select corporation'
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/helpers/validation.js